import React, { useState, useRef, useEffect } from "react";
import "./home.css";
import DomoticNavbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import RedesNetworking from "./RyN.jsx";
import SpecializedSoftware from "./licenciamiento-software.jsx";
import { scrollToHash } from "./scrollToHash";

// Imágenes servicios domotica
import computoyconferencia from "./img-domotic/computoyvideoconfierencia.png";
import computoyconferencia2 from "./img-domotic/computoyvideoconferencia2.png";
import electrosec_cctv from "./img-domotic/electrosec_cctv1.png";
import licenciamiento_soft from "./img-domotic/licenciamiento_de_software.png"; 
import licenciamiento_soft2 from "./img-domotic/licenciamiento_de_software2.png";
import licenciamiento_soft3 from "./img-domotic/licenciamiento_de_software3.png";
import networking_redes from "./img-domotic/networkingyredes.png";
import networking_redes2 from "./img-domotic/networkingyredes2.png"; 
import pantallas_edu_señ from "./img-domotic/pantallaseducativas_señalizaciondigital.png";
import pantallas_edu_señ2 from "./img-domotic/pantallaseducativas_señalizaciondigital2.png";
import parqueaderos_inteligentes from "./img-domotic/parqueaderos_inteligentes.png";
import parqueaderos_inteligentes2 from "./img-domotic/parqueaderos_inteligentes2.png";
import puertas_de_seguridad from "./img-domotic/puertas_seguridad.png";
import sistemas_energia_solar from "./img-domotic/solarsystem1.png";
import sistemas_energia_solar2 from "./img-domotic/solarsystem2.png";
import sistemas_pos from "./img-domotic/sistemasPOS.png";
import IntelligentParking from "./parqueaderosInteligentes.jsx";

// Imágenes del carrusel
import img1 from "./img/ctrl_clim.png";
import img2 from "./img/ctrl_voz.png";
import img3 from "./img/ctrl_voz2.png";
import img4 from "./img/ctrl_persi.png";
import img5 from "./img/ctril_iluminacion.png";
import img6 from "./img/ctrl_clim.png";
import img7 from "./img/ctrl_clim.png";

// Imágenes marcas
import marca1 from "./img/img_marcas/marca1.png";
import marca2 from "./img/img_marcas/marca2.png";
import marca3 from "./img/img_marcas/marca3.png";
import marca4 from "./img/img_marcas/marca4.png";
import marca5 from "./img/img_marcas/marca5.png";
import marca6 from "./img/img_marcas/marca6.png";
import marca7 from "./img/img_marcas/marca7.png";
import marca8 from "./img/img_marcas/marca8.png";
import marcah1 from "./img_marcas/insteon.png";
import marcah2 from "./img_marcas/fibaro.png";
import marcah3 from "./img_marcas/isde.png";
import marcah4 from "./img_marcas/lutron.png";
import marcah5 from "./img_marcas/honeywell.png";
import marcah6 from "./img_marcas/tuya.png";
import marcah7 from "./img_marcas/broadlink.png";
import marcah8 from "./img_marcas/zebra.png";
import marcah9 from "./img_marcas/viewsonic.png";
import marcah10 from "./img_marcas/cisco.png";
import marcah11 from "./img_marcas/fortinet.png";
import marcah12 from "./img_marcas/aruba.png";
import marcah13 from "./img_marcas/ruijie.png";
import marcah14 from "./img_marcas/ubiquiti.png";
import marcah15 from "./img_marcas/mikrotik.png";
import marcah16 from "./img_marcas/hikvision.png";
import marcah17 from "./img_marcas/zkteco.png";
import marcah18 from "./img_marcas/sat.png";
import marcah19 from "./img_marcas/lg.png";
import marcah20 from "./img_marcas/3nstar.png";
import marcah21 from "./img_marcas/ditec.png";
import marcah22 from "./img_marcas/roger.png";
import marcah23 from "./img_marcas/locher.png";
import marcah24 from "./img_marcas/seip.png";
import marcah25 from "./img_marcas/potter.png";
import marcah26 from "./img_marcas/gst.png";
import marcah27 from "./img_marcas/kidde.png";
import marcah28 from "./img_marcas/cofen.png";
import marcah29 from "./img_marcas/mircom.png";
import marcah30 from "./img_marcas/intelbras.png";
import marcah31 from "./img_marcas/dsc.png";
import marcah32 from "./img_marcas/risco.png";
import marcah33 from "./img_marcas/paradox.png";
import marcah34 from "./img_marcas/hagroy.png";
import marcah35 from "./img_marcas/linseng.png";
import marcah36 from "./img_marcas/panther.png";
import marcah37 from "./img_marcas/liftmaster.png";
import marcah38 from "./img_marcas/bft.png";
import marcah39 from "./img_marcas/cameditec.png";
import marcah40 from "./img_marcas/pilomat.png";
import marcah41 from "./img_marcas/tiesdi.png";
import marcah42 from "./img_marcas/anson.png";
import marcah43 from "./img_marcas/kaadas.png";
import marcah44 from "./img_marcas/lonbon.png";
import marcah45 from "./img_marcas/axis.png";
import marcah46 from "./img_marcas/hanwha.png";
import ContactForm from "./Contacto.jsx";

const brands = [
  { name: "INSTEÓN", image: marcah1 },
  { name: "FIBARO", image: marcah2 },
  { name: "ISDE", image: marcah3 },
  { name: "LUTRON", image: marcah4 },
  { name: "HONEYWELL", image: marcah5 },
  { name: "TUYA", image: marcah6 },
  { name: "BROADLINK", image: marcah7 },
  { name: "ZEBRA", image: marcah8 },
  { name: "VIEWSONIC", image: marcah9 },
  { name: "CISCO", image: marcah10 },
  { name: "FORTINET", image: marcah11 },
  { name: "ARUBA", image: marcah12 },
  { name: "RUJIIE-REYEE", image: marcah13 },
  { name: "UBIQUITI", image: marcah14 },
  { name: "MICROTIK", image: marcah15 },
  { name: "HIKVISION", image: marcah16 },
  { name: "ZKTECO", image: marcah17 },
  { name: "SAT", image: marcah18 },
  { name: "LG", image: marcah19 },
  { name: "3NSTAR", image: marcah20 },
  { name: "DITEC", image: marcah21 },
  { name: "ROGER", image: marcah22 },
  { name: "LOCHER", image: marcah23 },
  { name: "SEIP", image: marcah24 },
  { name: "POTTER", image: marcah25 },
  { name: "GST", image: marcah26 },
  { name: "KIDDE", image: marcah27 },
  { name: "COFEN", image: marcah28 },
  { name: "MIRCOM", image: marcah29 },
  { name: "INTELBRAS", image: marcah30 },
  { name: "DSC", image: marcah31 },
  { name: "RISCO", image: marcah32 },
  { name: "PARADOX", image: marcah33 },
  { name: "HAGROY", image: marcah34 },
  { name: "LINSENG", image: marcah35 },
  { name: "PANTHER", image: marcah36 },
  { name: "LIFTMASTER", image: marcah37 },
  { name: "BFT", image: marcah38 },
  { name: "CAMEDITEC", image: marcah39 },
  { name: "PILOMAT", image: marcah40 },
  { name: "TIESDI", image: marcah41 },
  { name: "ANSON", image: marcah42 },
  { name: "KAADAS", image: marcah43 },
  { name: "LONBON", image: marcah44 },
  { name: "AXIS", image: marcah45 },
  { name: "HANWHA", image: marcah46 }
];

const marcas = [marca1, marca2, marca3, marca4, marca5, marca6, marca7, marca8];

const Home = () => {
  const images = [img1, img2, img3, img4, img5, img6, img7];
  const carouselRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const itemsPerView = 5;
  const totalItems = brands.length;

  const initiateVoiceCommand = () => {
    console.log("Iniciando comando de voz...");
  };

  const nextSlide = () => {
    const nextIndex = (currentIndex + 1) % Math.ceil(totalItems / itemsPerView);
    setCurrentIndex(nextIndex);
    scrollToIndex(nextIndex);
  };

  const prevSlide = () => {
    const prevIndex = (currentIndex - 1 + Math.ceil(totalItems / itemsPerView)) % Math.ceil(totalItems / itemsPerView);
    setCurrentIndex(prevIndex);
    scrollToIndex(prevIndex);
  };

  const scrollToIndex = (index) => {
    if (carouselRef.current) {
      const scrollAmount = carouselRef.current.offsetWidth * (index * itemsPerView / totalItems);
      carouselRef.current.scrollTo({
        left: scrollAmount,
        behavior: "smooth"
      });
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 8000);

    return () => clearInterval(interval);
  }, [currentIndex]);

  return (
    <div className="domotic-home">
      <DomoticNavbar />

      <div className="services-alt-wrapper" style={{ marginTop: '8%', position: 'relative', zIndex: 10 }}>
  <section id="alt-servicios" className="alt-section">
    <div className="section-header">
      <h2 className="section-title">NUESTRAS SOLUCIONES TECNOLÓGICAS</h2>
      <div className="section-divider"></div>
    </div>

    {/* Solución 1 */}
    <a href="/RedesNetworking" className="service-row">
      <div className="service-item">
        <div className="service-image-container">
          <img src={networking_redes} alt="Networking y Redes" className="service-image" />
          <div className="image-overlay"></div>
        </div>
        <div className="service-content">
          <h3 className="service-title">NETWORKING Y REDES</h3>
          <p className="service-description">
            Infraestructura de red robusta y escalable para entornos empresariales con 
            tecnología de última generación y soporte especializado.
          </p>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 2 */}
    <a href="/SistemasPOS" className="service-row reverse">
      <div className="service-item">
        <div className="service-content">
          <h3 className="service-title">SISTEMAS POS</h3>
          <p className="service-description">
            Soluciones completas para puntos de venta inteligentes que integran hardware 
            y software para optimizar tus operaciones comerciales.
          </p>
        </div>
        <div className="service-image-container">
          <img src={sistemas_pos} alt="Sistemas POS" className="service-image" />
          <div className="image-overlay"></div>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 3 */}
    <a href="/SolarSystems" className="service-row">
      <div className="service-item">
        <div className="service-image-container">
          <img src={sistemas_energia_solar} alt="Energía Solar" className="service-image" />
          <div className="image-overlay"></div>
        </div>
        <div className="service-content">
          <h3 className="service-title">ENERGÍA SOLAR</h3>
          <p className="service-description">
            Soluciones sostenibles y eficientes para reducir costos operativos y 
            contribuir con el medio ambiente mediante tecnología solar avanzada.
          </p>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 4 */}
    <a href="/Puertas-Seguridad" className="service-row reverse">
      <div className="service-item">
        <div className="service-content">
          <h3 className="service-title">PUERTAS DE SEGURIDAD</h3>
          <p className="service-description">
            Sistemas de control de acceso de última generación con tecnología biométrica, 
            tarjetas RFID y control remoto para máxima seguridad.
          </p>
        </div>
        <div className="service-image-container">
          <img src={puertas_de_seguridad} alt="Puertas de Seguridad" className="service-image" />
          <div className="image-overlay"></div>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 5 */}
    <a href="/IntelligentParking" className="service-row">
      <div className="service-item">
        <div className="service-image-container">
          <img src={parqueaderos_inteligentes} alt="Parqueaderos Inteligentes" className="service-image" />
          <div className="image-overlay"></div>
        </div>
        <div className="service-content">
          <h3 className="service-title">PARQUEADEROS INTELIGENTES</h3>
          <p className="service-description">
            Gestión automatizada de estacionamientos con sensores, cámaras y 
            sistemas de pago integrados para una experiencia sin fricciones.
          </p>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 6 */}
    <a href="/Pantallas-Señalización" className="service-row reverse">
      <div className="service-item">
        <div className="service-content">
          <h3 className="service-title">PANTALLAS EDUCATIVAS</h3>
          <p className="service-description">
            Soluciones visuales para educación y navegación con pantallas interactivas, 
            sistemas de señalización digital y contenido dinámico.
          </p>
        </div>
        <div className="service-image-container">
          <img src={pantallas_edu_señ} alt="Pantallas Educativas" className="service-image" />
          <div className="image-overlay"></div>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 7 */}
    <a href="/licenciamiento-software" className="service-row">
      <div className="service-item">
        <div className="service-image-container">
          <img src={licenciamiento_soft} alt="Licenciamiento de Software" className="service-image" />
          <div className="image-overlay"></div>
        </div>
        <div className="service-content">
          <h3 className="service-title">LICENCIAMIENTO DE SOFTWARE</h3>
          <p className="service-description">
            Soluciones legales y optimizadas para tu negocio con licencias originales, 
            actualizaciones garantizadas y soporte técnico especializado.
          </p>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 8 */}
    <a href="/SecurityCctv" className="service-row reverse">
      <div className="service-item">
        <div className="service-content">
          <h3 className="service-title">ELECTRO SEGURIDAD</h3>
          <p className="service-description">
            Sistemas integrales de vigilancia y protección con CCTV de alta definición, 
            alarmas inteligentes y monitoreo remoto 24/7.
          </p>
        </div>
        <div className="service-image-container">
          <img src={electrosec_cctv} alt="Electro Seguridad" className="service-image" />
          <div className="image-overlay"></div>
        </div>
      </div>
      <div className="service-divider"></div>
    </a>

    {/* Solución 9 */}
    <a href="/ComputoVideoConferencia" className="service-row">
      <div className="service-item">
        <div className="service-image-container">
          <img src={computoyconferencia} alt="Cómputo y Videoconferencia" className="service-image" />
          <div className="image-overlay"></div>
        </div>
        <div className="service-content">
          <h3 className="service-title">CÓMPUTO Y VIDEOCONFERENCIA</h3>
          <p className="service-description">
            Equipos y soluciones para comunicación empresarial con tecnología de 
            videoconferencia profesional y equipos de cómputo de alto rendimiento.
          </p>
        </div>
      </div>
    </a>
  </section>
</div>

      <section id="seccion-marcas" className="brand-carousel-container">
        <div className="brand-header">
          <h2 className="brand-title">TRABAJAMOS CON LAS MEJORES MARCAS</h2>
          <div className="brand-controls">
            <button 
              className="carousel-prev" 
              aria-label="Anterior"
              onClick={prevSlide}
            >
              <svg viewBox="0 0 24 24">
                <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
              </svg>
            </button>
            <button 
              className="carousel-next" 
              aria-label="Siguiente"
              onClick={nextSlide}
            >
              <svg viewBox="0 0 24 24">
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
              </svg>
            </button>
          </div>
        </div>

        <div className="brand-carousel" ref={carouselRef}>
          {brands.map((brand, idx) => (
            <a 
              key={idx} 
              href={brand.url} 
              className="brand-card"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="brand-image-container">
                <img 
                  src={brand.image} 
                  alt={brand.name} 
                  className="brand-image"
                  loading="lazy"
                />
                <div className="brand-overlay">
                  <span className="brand-name">{brand.name}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </section>
<ContactForm/>
      <Footer/>
    </div>
  );
};

export default Home;